export enum Report {
  KeywordScreening = 0,
  SearchStrategy = 1,
  AcceptedCompanies = 2,
  AcceptedRejectedCompanies = 3,
  BdMatrix = 4,
  EliminationChart = 5,
  EngagementCode = 6,
  IrMatrix = 7,
  PLISummaryReport = 8,
  AcceptedCompaniesFinancialInfo = 9,
  PLISummaryReportAutoAdjustments = 10,
  AllFinancialInfo = 11,
  SearchStrategyExport = 12,
  DetailedPLISummaryReport = 13,
  SearchWriteUp = 14,
  CompaniesDetailsReport = 15,
  SegmentedFinancialReport = 16,
  StudyByDateRangeReport = 18,
}
